module.exports = __webpack_public_path__ + "static/media/Simon.3625b6d0.jpg";